import { getTokenFromStorage } from '@src/utills/storage';
import React, { useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Router } from '@uhg-abyss/web/ui/Router'
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';

export const PrivateRoutes = () => {
  const { navigate } = useRouter();
  const auth = {
    hasToken: getTokenFromStorage() !== '',
  };

  useEffect(() => {
    if (!auth.hasToken) navigate('/login')
  }, [auth.hasToken])

  return <Router.Outlet />
};
